
import { AssetMaintenanceRowsEntityDecoratorBase } from './asset-maintenance-rows.decorator.base';
import { AssetMaintenanceEntityDecorator } from './asset-maintenance.decorator';


export class AssetMaintenanceRowsEntityDecorator extends AssetMaintenanceRowsEntityDecoratorBase<any> {
  constructor() {
    super(new AssetMaintenanceEntityDecorator(), null);
  }
}



